import { useEffect, useState } from "react";

import searchProducts from "@/api/requests/searchProducts";
import { Product } from "@/custom-types/Product";
import useDomainCountryCode from "@/hooks/useDomainCountryCode";
import { useSelector } from "@/redux/hooks";
import { getCoordinates } from "@/redux/selectors/location";

import { ProductsCarousel, ProductsCarouselProps } from "../ProductsCarousel";
import { ProductsCarouselSkeleton } from "../ProductsCarouselSkeleton";

interface ProductsCarouselWithDataProps
  extends Pick<
    ProductsCarouselProps,
    "header" | "carouselPath" | "seeMoreText" | "carouselClassName"
  > {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any -- TODO: fix me please, do not replicate
  filter: Record<string, any>;
}

export const ProductsCarouselWithData = ({
  filter,
  ...props
}: ProductsCarouselWithDataProps) => {
  const countryCode = useDomainCountryCode();
  const coordinates = useSelector(getCoordinates);
  const [products, setProducts] = useState<Product[] | null>(null);

  useEffect(() => {
    searchProducts(
      {
        collapse: "brand",
        filter,
        sort: { 0: { brand_status: "desc" } },
        take: 8,
      },
      countryCode,
      coordinates,
    ).then(({ products }) => setProducts(products));
  }, []);

  if (products === null) {
    return <ProductsCarouselSkeleton {...props} />;
  } else {
    return <ProductsCarousel {...props} products={products} />;
  }
};
